import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
	const { user, token, loading } = useContext(AuthContext);
	const location = useLocation();

	if (loading) {
		return <div className="w-full h-screen flex items-center justify-center">Loading...</div>;
	}
	if (!token || !user) {
		return <Navigate to="/login" replace state={{ from: location }} />;
	}
	return children;
}


